import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]

import ShopService from "@/services/shop.service";
import {ref} from "vue";
import IShop from "@/interfaces/IShop";
import StorageService from "@/services/storage.service";
import {LOCAL_STORAGE_KEYS_NAMES} from "@/constants/local_storage_keys_names";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectShop',
  setup(__props) {

const shops = ref<IShop[]>();
const selectedShopId = ref<number | undefined>();
const main = async () => {
  const data = await ShopService.read();
  if (data?.data?.result) {
    shops.value = data.data.result;
    const storageShopId = StorageService.getItem(LOCAL_STORAGE_KEYS_NAMES.SHOP_ID);
    if (storageShopId) {
      selectedShopId.value = Number(storageShopId);
    } else {
      if (shops.value) {
        const shopId = shops.value[0].id;
        selectedShopId.value = shopId;
        StorageService.setItem(LOCAL_STORAGE_KEYS_NAMES.SHOP_ID, shopId);
      }
    }
  }
};

const selectShopId = () => {
  StorageService.setItem(LOCAL_STORAGE_KEYS_NAMES.SHOP_ID, selectedShopId.value);
  window.location.reload();
};

main();


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    onChange: _cache[0] || (_cache[0] = ($event: any) => (selectShopId())),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedShopId).value = $event)),
    id: "countries",
    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shops.value, (shop) => {
      return (_openBlock(), _createElementBlock("option", {
        value: shop.id
      }, _toDisplayString(shop.name) + " (" + _toDisplayString(shop?.city['name']) + ") ", 9, _hoisted_1))
    }), 256))
  ], 544)), [
    [_vModelSelect, selectedShopId.value]
  ])
}
}

})